import { useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
// import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
// import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
// import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import IconButton from '@material-ui/core/IconButton';
// import styled from '@material-ui/core/styles/styled';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import { useFilters } from '../../../../services/filters/hooks/useFilters';
import {
  DynamicAuctionFilters,
  SearchFilters,
} from 'shared/types/api/getAuctions';
import { AccordionFilters } from './filters/AccordionFilters';
import { isMsrpFilterValid } from 'services/filters/utils';
import {
  CarPreferencesLabelMui5,
  DoubleEmptyFilterDivider,
  EmptyFilterDivider,
  FilterDividerMui5,
} from './components';
import {
  AnnualMileageFilter,
  AuctionStatusFilter,
  AuctionTypeFilter,
  DistanceFilter,
  FeatureFilter,
  MakeFilter,
  ModelFilter,
  MonthlyBudgetFilter,
  MSRPFilter,
  TermLengthFilter,
  TrimFilter,
  VehicleConditionFilter,
  YearFilter,
  ZipcodeFilter,
} from './filters';
import { SelectedFiltersWithDivider } from './filters/SelectedFiltersWithDivider';
import { CreditTierFilter } from './filters/CreditTierFilter';
import Box from '@mui/material/Box';
import { FeaturedFilter } from './filters/FeaturedFilter';
import { LeaseFinanceToggle } from './filters/LeaseFinanceToggle';
import { useRecoilValue } from 'recoil';
import { scanModeInputAtom } from 'containers/deal/recoil/atoms';
import { MSAPIScanMode } from 'shared/types/marketScan';
import { EditSearchDownPayment } from './filters/EditSearchDownPayment';
import { TariffFreeDealsFilter } from './filters/TariffFreeDealsFilter';

// const AdditionalFiltersLabel = styled('span')(({ theme }) => ({
//   paddingTop: theme.spacing(0.7),
//   color: theme.palette.primary.main,
//   fontSize: '1rem',
// }));

export const Filters = ({
  dynamicFilters,
  searchFilters,
}: FiltersPropsType): JSX.Element => {
  const { filters, setFilterValue, setFiltersValue } = useFilters();
  const showMSRPFilter = isMsrpFilterValid(dynamicFilters) || null;
  const showDistanceFilter = Boolean(filters.zipcode) || null;
  const [showAdditionalFilters] = useState(false);
  const scanMode = useRecoilValue(scanModeInputAtom);
  const isLease = scanMode === MSAPIScanMode.Lease;

  return (
    <Box>
      <SelectedFiltersWithDivider />
      <LeaseFinanceToggle withTitle={true} setFilter={true} />
      <EditSearchDownPayment />
      <DoubleEmptyFilterDivider />
      <MonthlyBudgetFilter setFiltersValue={setFiltersValue} />
      <DoubleEmptyFilterDivider />
      <FeaturedFilter setFilterValue={setFilterValue} />
      <TariffFreeDealsFilter setFilterValue={setFilterValue} />
      <DoubleEmptyFilterDivider />
      <ZipcodeFilter setFilterValue={setFilterValue} />
      {showDistanceFilter && (
        <>
          <EmptyFilterDivider />
          <DistanceFilter setFilterValue={setFilterValue} />
        </>
      )}
      <DoubleEmptyFilterDivider />
      <FormGroup>
        <CarPreferencesLabelMui5>
          <FieldLabelIconMui5 icon={faTachometerAlt} color='primary' />
          Car Preferences
        </CarPreferencesLabelMui5>
        <YearFilter
          setFilterValue={setFilterValue}
          years={searchFilters.years}
        />
        <MakeFilter
          setFilterValue={setFilterValue}
          makes={searchFilters.makes}
        />
        <ModelFilter
          setFiltersValue={setFiltersValue}
          models={searchFilters.models}
        />
        <TrimFilter
          setFiltersValue={setFiltersValue}
          trims={searchFilters.trims}
        />
        <FeatureFilter setFilterValue={setFilterValue} />
      </FormGroup>
      <FilterDividerMui5 />
      <TermLengthFilter setFilterValue={setFilterValue} />
      {isLease && (
        <>
          <DoubleEmptyFilterDivider />
          <AnnualMileageFilter setFilterValue={setFilterValue} />
        </>
      )}
      <DoubleEmptyFilterDivider />
      <CreditTierFilter setFilterValue={setFilterValue} />
      {showMSRPFilter && (
        <>
          <FilterDividerMui5 />
          <MSRPFilter
            dynamicFilters={dynamicFilters}
            setFilterValue={setFilterValue}
          />
        </>
      )}
      <DoubleEmptyFilterDivider />
      {/* TODO SEARCH: Return Additional filters */}
      {/*<FilterDivider />
        <Box mb={1} display='flex' justifyContent='space-between'>
          <AdditionalFiltersLabel>
            <FieldLabelIcon icon={faFilter} color='primary' />
            ADDITIONAL FILTERS
          </AdditionalFiltersLabel>
          <IconButton
            onClick={() => {
              setShowAdditionalFilters(!showAdditionalFilters);
            }}
          >
            <FontAwesomeIcon
              icon={showAdditionalFilters ? faChevronUp : faChevronDown}
              size='xs'
            />
          </IconButton>
        </Box>*/}
      {showAdditionalFilters && (
        <>
          <AuctionTypeFilter setFilterValue={setFilterValue} />
          <FilterDividerMui5 />
          <AuctionStatusFilter setFilterValue={setFilterValue} />
          <FilterDividerMui5 />
          <VehicleConditionFilter setFilterValue={setFilterValue} />
          <br />
          <AccordionFilters dynamicFilters={dynamicFilters} />
        </>
      )}
    </Box>
  );
};

type FiltersPropsType = {
  dynamicFilters: DynamicAuctionFilters;
  searchFilters: SearchFilters;
};
